import * as React from 'react';
import { AuthLock } from '../auth/AuthLock';
import HeaderLogo from './HeaderLogo';

export interface IPublicHeaderProps {
    scrollTo: (e: string) => void;
}

interface IPublicHeaderState {
    navRightClassName: string;
}

export default class PublicHeader extends React.Component<
    IPublicHeaderProps,
    IPublicHeaderState
> {
    constructor(props: IPublicHeaderProps) {
        super(props);

        this.state = {
            navRightClassName: 'hidden'
        };
    }

    doAuthLogin() {
        AuthLock.getInstance().showLogIn();
    }

    toggleNavRight() {
        let className =
            this.state.navRightClassName === 'hidden' ? 'opened' : 'hidden';
        this.setState({
            navRightClassName: className
        });
    }

    render() {
        return (
            <header className="header header--unlogged scrolled">
                <HeaderLogo onClick={() => this.props.scrollTo('home')} />

                <nav className="nav">
                    <ul>
                        <li>
                            <span onClick={() => this.props.scrollTo('howto')}>
                                how it works
                            </span>
                        </li>
                        <li>
                            <span
                                onClick={() => this.props.scrollTo('wetnotes')}
                            >
                                wetnotes
                            </span>
                        </li>
                        <li>
                            <span onClick={() => this.props.scrollTo('footer')}>
                                contact
                            </span>
                        </li>
                        <li>
                            <a
                                onClick={() => this.doAuthLogin()}
                                className="btn btn--smallpill btn-white btn-login"
                            >
                                LOGIN
                            </a>
                        </li>
                    </ul>
                </nav>

                <nav className={'nav-right ' + this.state.navRightClassName}>
                    <ul>
                        <li>
                            <span
                                onClick={() => {
                                    this.props.scrollTo('howto');
                                    this.toggleNavRight();
                                }}
                            >
                                How it works
                            </span>
                        </li>
                        <li>
                            <span
                                onClick={() => {
                                    this.props.scrollTo('wetnotes');
                                    this.toggleNavRight();
                                }}
                            >
                                WetNotes
                            </span>
                        </li>
                        <li>
                            <span
                                onClick={() => {
                                    this.props.scrollTo('footer');
                                    this.toggleNavRight();
                                }}
                            >
                                Contact
                            </span>
                        </li>
                        <li>
                            <a
                                onClick={event => {
                                    this.toggleNavRight();
                                    this.doAuthLogin();
                                }}
                                className="btn btn--smallpill btn-white"
                            >
                                Login
                            </a>
                        </li>
                    </ul>
                </nav>

                <button
                    type="button"
                    className="navbar-toggle collapsed"
                    onClick={() => this.toggleNavRight()}
                >
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                </button>
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/PublicHeader.tsx